import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.m.scss';

const propTypes = {
  loading: PropTypes.bool,
};

const Loader = ({ loading }) => {
  if (!loading) return <noscript />;

  return (
    <div className={styles.loader}>
      <div className={styles.spinner} />
      <p className="text-white mt-2">Loading</p>
    </div>
  );
};

Loader.propTypes = propTypes;

export default Loader;
